export default [
    {path: '/help', screen: 'misc/Help', secured: true},
    {path: '/', screen: 'home', secured: true, exact: true, strict: true},
    {screen: 'notFound', secured: false},
]